export const plans1 = [
	{
		title: 'ÚNICO PAGO',
		descrition: '',
		price: '$399 USD',
		priceBefore: '$499 USD',
		urls: {
			ninguno: 'https://checkout.bold.co/payment/LNK_Y10H2DFFG3',
			internacional: 'https://checkout.wompi.co/shipping',
		},
		temario: 'https://drive.google.com/file/d/1_ydjtZ3CJ-6nBCndavf-agaUwd7BU-n-/view?usp=sharing',
		items: [
			{
				title: 'Acceso a todos los entrenamientos.',
			},
			{
				title: 'Acceso por un año al contenido.',
			},
		],
		center: true,
		top: false,
		ball: false,
		promo: '30% DTO',
		type: 'presencial',
	},
];
